
import "/app/src/modules/zy-crm/components/product-form-section/style.module.less?modules";
export default {"toolbarMain": `toolbarMain-ifeGxbW_`,"emptyWrap": `emptyWrap-FfMYiZN8`,"toolbar": `toolbar-jB-4U5VN`,"root": `root-iTuKvzB3`,"toolbarTitle": `toolbarTitle-TZBmW3of`,"addRowButton": `addRowButton-LNLY5N40`,"addRowButtonText": `addRowButtonText-IaKR43u8`,"tableWrap": `tableWrap-Er0u5xXb`}
